import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import ChevronDownIcon from "../../assets/ChevronDownIcon";
import OrgSelect from "./OrgSelect";
import { AccessibleOrganization } from "../../store/slices/OrganizationsV3Slice";
import { getOrganizationName } from "../pages/Organizations/utils";

interface OrgSelectPopoverProps {
  options: AccessibleOrganization[];
  value: number | null;
  onChange: (organizationId: number | null) => void;
  // Button text while nothing is selected.
  placeholder?: string;
  // Label of the null option; omitted = an org must be picked.
  allLabel?: string;
  isLoading?: boolean;
  isError?: boolean;
  disabled?: boolean;
  // Called when the button is pressed, e.g. to close sibling dropdowns.
  onOpen?: () => void;
}

// "Organization ▾" button that opens the searchable org hierarchy (OrgSelect).
// Shared by the global user list's Organization filter (ADM-89) and the invite
// modal's Organization fields (ADM-92); styled like FilterDropdown's button.
const OrgSelectPopover = ({
  options,
  value,
  onChange,
  placeholder = "Organization",
  allLabel,
  isLoading = false,
  isError = false,
  disabled = false,
  onOpen,
}: OrgSelectPopoverProps) => {
  const selected = options.find((org) => org.id === value);

  return (
    <Popover className="relative">
      <PopoverButton
        onClick={onOpen}
        disabled={disabled}
        className="flex max-w-[240px] items-center gap-1 rounded-lg border border-brColor px-3 py-2 text-sm font-semibold text-textColor3 shadow-light-sm hover:bg-gray-50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
      >
        <span className="truncate">{selected ? getOrganizationName(selected) : placeholder}</span>
        <ChevronDownIcon />
      </PopoverButton>
      <PopoverPanel className="absolute right-0 z-20 mt-1 w-80 rounded-lg border border-[#e5e5e5] bg-white p-2 shadow-[0px_12px_20px_0px_rgba(0,0,0,0.1)]">
        {({ close }) => (
          <OrgSelect
            options={options}
            value={value}
            onChange={(organizationId) => {
              onChange(organizationId);
              close();
            }}
            allLabel={allLabel}
            isLoading={isLoading}
            isError={isError}
          />
        )}
      </PopoverPanel>
    </Popover>
  );
};

export default OrgSelectPopover;
